<template>
  <v-card>
    <v-toolbar dark color="darken-2" elevation="0" @short="true">
      <v-btn icon dark @click="fechar()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        <span v-if="isNovo">Nova Publicação</span>
        <span v-else>Editar Publicação</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="salvarPublicacao()">Salvar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row>
          <ComboGrupo
            v-model="publicacao.grupo_id"
            :object="publicacao.grupo_id"
            color="black"
            :multiple="false"
            :change="changeCombo"
          />
        </v-row>
        <v-row style="align-items: center;">
          <v-col cols="6" md="4" align-self="center" v-if="this.showAutor">
            <mb-select-autor v-model="publicacao.autor_id" />
          </v-col>
          <v-col cols="6" md="8" class="mb-5" v-if="this.showTitulo">
            <mb-text-field label="Título" v-model="publicacao.titulo" />
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-5">
          <v-col cols="12" class="mb-8">
            <vue-editor id="editor" v-model="publicacao.texto" v-if="this.showEditor" />
          </v-col>
          <v-col cols="3" v-if="this.showImagem">
            <v-file-input
              :rules="rules"
              v-model="imagemFile"
              show-size
              accept="image/png, image/jpeg"
              placeholder="Escolher a imagem"
              prepend-icon="mdi-camera"
              label="Imagem"
              color="black"
              @change="imageToBase64"
            />
          </v-col>
          <v-col cols="3" class="ml-5" v-if="this.showCor">
            <mb-color-picker label="Cor da Publicação" v-model="publicacao.cor_fundo" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">
            <mb-data
              label="Data da Publicação"
              :soloInverted="false"
              prependInnerIcon
              prependIcon="event"
              :data="publicacao.data"
              @dataSelecionada="publicacao.data = $event"
            />
          </v-col>
          <v-col cols="2" class="ml-5">
            <v-checkbox label="Publicado" color="black" v-model="publicacao.publicado" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import ComboGrupo from "@/widget/ComboGrupos.vue";
import PublicacaoInput from "@/classes/publicacaoInput.js";
import { VueEditor } from "vue2-editor";
export default {
  props: ["isNovo", "setPublicacao"],
  data() {
    return {
      publicacao: new PublicacaoInput(),

      showAutor: false,
      showTitulo: false,
      showImagem: false,
      showCor: false,
      showEditor: false,

      imagemFile: null,
      rules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Imagem não pode ser maior que 2 MB!",
      ],
    };
  },
  mounted() {
    this.carregaPublicacao();
  },
  methods: {
    carregaPublicacao() {
      this.publicacao = this.setPublicacao;
      this.publicacao.imagem = [];
      if (this.$utils.isNotNull(this.setPublicacao)) {
        if (this.setPublicacao.midia && this.setPublicacao.midia.length > 0) {
          for (
            let index = 0;
            index < this.setPublicacao.midia.length;
            index++
          ) {
            const midia = this.setPublicacao.midia[index];
            for (
              let imagemIndex = 0;
              imagemIndex < midia.imagem.length;
              imagemIndex++
            ) {
              this.publicacao.imagem.push(
                this.setPublicacao.midia[index].imagem[imagemIndex]
              );
            }
          }
        }
        this.publicacao.grupo_id = this.publicacao.grupo;
        this.publicacao.autor_id = this.publicacao.autor.id;
        this.publicacao.editorial_id = this.publicacao.editorial;
        this.publicacao.data = new Date(this.publicacao.data)
          .toISOString()
          .substr(0, 10);
        this.changeCombo();
      }
    },
    salvarPublicacao() {
      switch (this.publicacao.grupo_id.descricao) {
        case "Principal":
          if (this.$utils.isNull(this.publicacao.texto)) {
            this.$toast.warning("Informe o texto.");
            return;
          }
          if (this.$utils.isNull(this.publicacao.imagem)) {
            this.$toast.warning("Selecione uma imagem.");
            return;
          }
          break;
        case "Nota":
        case "Em Alta":
        case "Em Baixa":
          if (this.$utils.isNull(this.publicacao.titulo)) {
            this.$toast.warning("Informe um titulo.");
            return;
          }
          if (this.$utils.isNull(this.publicacao.texto)) {
            this.$toast.warning("Informe o texto.");
            return;
          }
          break;
        case "Entrevista":
          if (this.$utils.isNull(this.publicacao.autor_id)) {
            this.$toast.warning("Informe o entrevistado.");
            return;
          }
          if (this.$utils.isNull(this.publicacao.titulo)) {
            this.$toast.warning("Informe um titulo.");
            return;
          }
          if (this.$utils.isNull(this.publicacao.texto)) {
            this.$toast.warning("Informe o texto.");
            return;
          }
          break;
        default:
          break;
      }

      this.$emit("salvar", this.publicacao);
    },
    changeCombo() {
      this.clear();
      switch (this.publicacao.grupo_id.descricao) {
        case "Principal":
          this.showImagem = true;
          this.showEditor = true;
          break;
        case "Nota":
        case "Eu Recomendo":
        case "Em Alta":
        case "Em Baixa":
          this.showTitulo = true;
          this.showEditor = true;
          break;
        case "Entrevista":
          this.showAutor = true;
          this.showTitulo = true;
          this.showEditor = true;
          break;
        default:
          break;
      }
    },
    clear() {
      this.showAutor = false;
      this.showTitulo = false;
      this.showImagem = false;
      this.showCor = false;
      this.showEditor = false;
      this.publicacao = this.setPublicacao;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    imageToBase64() {
      this.getBase64(this.imagemFile).then((data) => {
        if (this.publicacao.imagem) {
          this.publicacao.imagem.push(data);
        } else {
          this.publicacao.imagem = [];
          this.publicacao.imagem.push(data);
        }
      });
    },
    fechar() {
      this.$emit("fechar", false);
    },
  },
  components: {
    ComboGrupo,
    VueEditor,
  },
};
</script>

<style>
</style>
